import { useRef, useSyncExternalStore } from 'react';
import { getCurrentSiteId, subscribeCurrentSiteId } from '../services/api';

/**
 * Site id used for X-Site-Id, as React state. Updates in the same turn as
 * setCurrentSiteId, so a page can drop the previous site's rows before paint.
 */
export function useCurrentSiteId() {
  return useSyncExternalStore(subscribeCurrentSiteId, getCurrentSiteId, getCurrentSiteId);
}

/**
 * Run `clear` during render when the site id changes, so stale counts are not
 * painted under the new site. `clear` must only call setState.
 */
export function useClearOnSiteChange(siteId, clear) {
  const previous = useRef(siteId);
  if (previous.current !== siteId) {
    previous.current = siteId;
    clear();
  }
}
